import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { Observable, of, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

import { AuthFacadeService, MessageService } from '@venecia/services';
import { ThreadUtil } from '@venecia/utils';

export const authInterceptor: HttpInterceptorFn =
    (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
        const translateService = inject(TranslateService);
        const messageService = inject(MessageService);

        if (req.url.includes('/api/flow')
            || req.url.includes('/config/')
            || req.url.includes('/i18n/')) {
            return next(req);
        }

        const authFacade = inject(AuthFacadeService);

        return authFacade
            .getValidAccessToken$()
            .pipe(
                switchMap((accessToken) => next(withBearer(req, accessToken))),
                catchError((err) => {
                    if (err instanceof HttpErrorResponse) {
                        const httpErrorResponse = err as HttpErrorResponse;
                        if (httpErrorResponse.status < 500) {
                            return throwError(() => err);
                        }
                    }
                    translateService.get('err.spa.unknown')
                        .subscribe(errorMsg => {
                            messageService.error(errorMsg);
                            ThreadUtil.sleep(2000);
                            window.location.reload();
                        });
                    return of();
                })
            );
    };

function withBearer(req: HttpRequest<unknown>, accessToken: string): HttpRequest<unknown> {
    return req.clone({ setHeaders: { Authorization: `Bearer ${accessToken}` } });
}